import type { BaselineEditorPage, FavoriteSummary } from '../api/types'
import { pageNumber, pageSourceKey } from './page-composition'

export type FavoriteMaterial = BaselineEditorPage & { favorite_id: string; asset_name: string; folder_name: string | null }

/** Stage immutable source pages independently of the baseline and the current favorite folder. */
export function stageFavorite(materials: FavoriteMaterial[], favorite: FavoriteSummary): FavoriteMaterial[] {
  if (materials.some(page => pageSourceKey(page) === pageSourceKey(favorite))) return materials
  return [...materials, {
    favorite_id: favorite.id, asset_name: favorite.asset_name ?? favorite.asset_id, folder_name: favorite.folder_name,
    page_ref: favorite.source_page_ref, ordinal: pageNumber(favorite.source_page_ref),
    source_revision_id: favorite.source_revision_id, source_page_ref: favorite.source_page_ref, preview_url: favorite.preview_url ?? null,
  }]
}
